<wuc-display-field *ngIf="isFutureProduct">
    <label>{{ modifiableFactorFuture?.factorDescription }}</label>
    <span>{{ modifiableFactorFuture?.factorIndicationDescription }}</span>
</wuc-display-field>
<wuc-display-field *ngIf="!isFutureProduct">
    <label>
        {{ premiumDeterminingFactor?.factorDescription }}
        <wuc-link *ngIf="isDamageFreeYears"
                    (clicked)="openDamageFreeYearsModal(purchasedProduct?.productId)">
            <wuc-icon-ui type="primary" icon="information" size="xs"></wuc-icon-ui>
        </wuc-link>
        <wuc-link *ngIf="isBonusMalusStep"
                    (clicked)="openBonusMalusStepModal(purchasedProduct?.productId)">
            <wuc-icon-ui type="primary" icon="information" size="xs"></wuc-icon-ui>
        </wuc-link>
    </label>
    <span>
        {{ premiumDeterminingFactor?.modifiableFactor?.factorValueDescription }}
        <wuc-link
            *ngIf="hasInformationTooltip"
            [insTooltip]="
                    'Klopt dit niet (helemaal)? U hoeft dat niet aan ons door te geven. Het maakt namelijk geen verschil voor uw dekking.'
                "
            orientation="center"
        >
            <wuc-icon-ui type="primary" icon="information" size="xs"></wuc-icon-ui>
        </wuc-link>
    </span>
    <wuc-link *ngIf="canAddPremiumDeterminingFactor"
              type="secondary"
              [iconRight]="selected ? 'arrow-up-bold' : 'arrow-down-bold'"
              iconSize="xs"
              (clicked)="toggleForm()"
              slot="action">{{ selected ? 'Sluiten' : 'Wijzigen'}}</wuc-link>
</wuc-display-field>
